import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { StateManagementService } from 'src/app/requests-detail-view/state-managemnet.service';
import { SubSink } from 'subsink';
import { DelegationService } from '../../../delegation/services/delegation.service';
import { RouterPathConfig } from '../../constants/router-path.config';
import { USER_ROLE } from '../../constants/user-role.enum';
import { IMenuItem } from '../../models/menu-item.model';
import { ApiRequestService } from '../../services/api-request.service';
import { AuthService } from '../../services/auth.service';
import { LoggedInUserService } from '../../services/logged-in-user.service';
import { RoutingHandlerService } from '../../services/routing-handler.service';
import { SidebarMenuService } from '../../services/sidebar-menu.service';
import { TranslateService } from '../../translate';
import { TuwaiqUtil } from '../../TuwaiqUtil';

@Component({
    selector: 'app-new-header',
    templateUrl: './new-header.component.html',
    styleUrls: ['./new-header.component.scss']
})
export class NewHeaderComponent implements OnInit, OnDestroy {
    isHome: boolean = false;
    menuList: IMenuItem[] = [{ id: 5, name: 'requests_header', path: '/admin/new-requests' }];
    dynamicMenuList: IMenuItem[] = [];
    selectedItem = this.menuList[0];
    subs = new SubSink();
    loggedInUserDetails;
    userRole;
    userRoleName: string;
    checked: boolean;
    userRoleEmpolyee = USER_ROLE.EMPLOYEE;
    userRoleEmpolyeeOperation = USER_ROLE.OPERATION_EMPLOYEE;
    languages = this.translateService.languages;
    otherLang$ = this.translateService.otherLang$;
    isWebView: boolean = false;
    dataManagementRoute = RouterPathConfig.dataManagmentRoute;
    callCenterClientManagementRoute = RouterPathConfig.CALL_CENTER_CLIENT_MANAGEMENT;
    statusText: string;
    isCollapsed = true;
    isDelegationActive = false;
    private isNavigatingToDelegation = false;

    constructor(
        private authService: AuthService,
        private sidebarMenuService: SidebarMenuService,
        private routingHandlerService: RoutingHandlerService,
        private location: Location,
        private cookies: CookieService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private router: Router,
        protected loggedInUserService: LoggedInUserService,
        private apiRequestService: ApiRequestService,
        private readonly translateService: TranslateService,
        private statemanagementService: StateManagementService,
        private delegationService: DelegationService
    ) {
        this.userRole = this.loggedInUserService.getUserRole();
        this.isHome = this.router.url.includes(RouterPathConfig.HOME_PATH);
        this.subs.sink = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isHome = event.url.includes(RouterPathConfig.HOME_PATH);
            }
        });
    }
    isShowDivIf = true;
    toggleDisplayDivIf() {
        this.isShowDivIf = !this.isShowDivIf;
    }

    ngOnInit(): void {
        this.isWebView = TuwaiqUtil.isWebView();
        this.userRole = this.loggedInUserService.getUserRole();
        this.userRoleName = this.getUserRoleName();
        this.isDelegationActive = this.delegationService.isDelegationActive();

        this.getViewAndLoggedInUserDetails();
        this.storeSuperAdminMenuItem();
        this.addItemsToMenuBasedOnRole();
        this.addFileManagementMenuItem();
        this.addPeriodicReviewMenuItem();

        // Only add delegation menu if the feature is active
        if (this.isDelegationActive) {
            this.addDelegationMenuItem();
        }

        this.updateDynamicMenuList();
        this.handleHeaderMenuList();
        this.subscribeToRouterChangeSetActiveHeaderMenu();
    }

    public switchLang(lang: string) {
        this.translateService.changeLang(lang);
        this.router.navigateByUrl('/reload-data');
        this.isCollapsed = true;
    }

    getUserRoleName() {
        return this.userRole.replaceAll('_', ' ').substring(5, this.userRole.length).toLowerCase();
    }

    handeleStatus() {
        if (this.loggedInUserDetails.status === 'AVAILABLE') {
            this.checked = true;
            this.statusText = 'active';
        } else {
            this.checked = false;
            this.statusText = 'notActive';
        }
    }
    addItemsToMenuBasedOnRole() {
        const userPath = this.routingHandlerService.getUserPathFromRole(this.userRole);
        if (!this.loggedInUserService.isAccountMangerOrRequester()) {
            this.menuList.unshift({ id: 2, name: 'strategy', path: '/strategy' });
        }
        this.menuList.unshift({ id: 0, name: 'home', path: '/home' });

        if (this.loggedInUserService.isDisplayCallRecord()) {
            this.menuList.push({ id: 13, name: 'callRecord', path: `/${userPath}/callRecord` });
        }
        if (this.loggedInUserService.canSeeDashboard()) {
            this.menuList.push({ id: 1, name: 'dashboards', path: `/${userPath}/dashboard` });
        }
        if (!this.loggedInUserService.isAccountMangerOrRequester()) {
            this.menuList.push({ id: 6, name: 'serviceCatalog', path: '/serviceCatalog' });
        }

        if (this.loggedInUserService.isDisplaySeenEmployeeManagement()) {
            this.menuList.push({ id: 7, name: 'empolyeeManagement', path: '/empolyee-managment' });
        }

        if (this.loggedInUserService.isAccountMangerInquires() || this.loggedInUserService.isAccountMangertBoth()) {
            this.menuList.push({ id: 8, name: 'clientManagementUsers', path: '/client-management-users', secondary_id: 51 });
        }
        if (this.loggedInUserService.isDisplayEServices()) {
            this.menuList.push({ id: 12, name: 'eServices', path: '/services', secondary_id: 42 });
        }

        if (this.loggedInUserService.canAccessMessageCenter()) {
            this.menuList.push({ id: 9, name: 'message-center', path: '/message-center' });
        }
        //this.userRole === USER_ROLE.STS_EMPLOYEE
        if (this.loggedInUserService.cannotSeeInquiries()) {
            const index = this.menuList.findIndex(menuItem => menuItem.id === 5 && menuItem.name === 'requests_header');
            if (index > -1) {
                this.menuList.splice(index, 1);
            }
        }
    }

    updateDynamicMenuList() {
        this.dynamicMenuList = this.menuList;
        this.updateMenuWithSubItems(this.dynamicMenuList, [2, 6], 'aboutSTS', 40);
        this.updateMenuWithSubItems(this.dynamicMenuList, [1, 5, 13], 'requests', 41);
        this.updateMenuWithSubItems(this.dynamicMenuList, [0, 7, 9, 4], 'notAllowed', 50);
        // this.menuList = this.dynamicMenuList;
    }
    storeSuperAdminMenuItem() {
        if (this.loggedInUserService.isSuperAdmin()) {
            this.menuList.push(RouterPathConfig.dataManagmentRoute);
        }
    }

    addFileManagementMenuItem() {
        if (this.loggedInUserService.isInternalUser()) {
            this.menuList.push(RouterPathConfig.fileManagmentRoute);
        }
    }

    addDelegationMenuItem() {
        this.menuList.push(RouterPathConfig.delegationRequestRoute);
    }

    addPeriodicReviewMenuItem() {
        if (this.loggedInUserService.isInternalUser()) {
            if (this.loggedInUserService.canAccessReports() || this.loggedInUserService.isInternalUsercanAccessReports())
                this.menuList.push(RouterPathConfig.periodicReviewReportRoute);
            else this.menuList.push(RouterPathConfig.periodicReviewSharedReportRoute);
        }
    }
    handleHeaderMenuList() {
        const urlWithOutParams = this.location.path().split('?')[0];
        const getUserPathFromURL = urlWithOutParams.trim().split('/')[1];
        this.resetRequestsPath();

        if (this.loggedInUserService.isSuperAdmin() && getUserPathFromURL === RouterPathConfig.DATA_MANAGEMENT) {
            this.selectedItem = this.menuList.find(item => item.id === 4);
        } else if (this.loggedInUserService.isInternalUser() && getUserPathFromURL === RouterPathConfig.FILE_MANAGEMENT) {
            this.selectedItem = this.menuList.find(item => item.id === 10);
        } else if (this.loggedInUserService.isInternalUser() && getUserPathFromURL === RouterPathConfig.PERIODIC_REVIEW) {
            this.selectedItem = this.menuList.find(item => item.id === 11);
            if (urlWithOutParams === '/periodic-review/shared-reports') {
                this.selectedItem.path = 'periodic-review/shared-reports';
            } else if (urlWithOutParams === '/periodic-review/reports') {
                this.selectedItem.path = 'periodic-review/reports';
            }
        } else if (getUserPathFromURL === RouterPathConfig.DELEGATION) {
            this.selectedItem = this.menuList.find(item => item.id === 15);
        } else if ((!getUserPathFromURL || getUserPathFromURL === RouterPathConfig.HOME_PATH) && (this.loggedInUserService.isSuperAdmin() || this.isAdmin())) {
            this.selectedItem = this.menuList[0];
        } else if (getUserPathFromURL === RouterPathConfig.STRATEGY) {
            this.selectedItem = this.menuList.find(item => item.id === 2);
        } else if (
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.NEW_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.ASSIGNED_TO_ME_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.COMPLETED_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.INPROGRESS_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.RETURNED_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.EMPLOYEE_MANAGEMENT_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.COMPLETED_HISTORY_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.TECHNICAL_OPERATIONS_REQUESTS)
        ) {
            this.selectedItem = this.menuList.find(item => item.id === 5);
            this.selectedItem.path = urlWithOutParams;
        } else if (urlWithOutParams.includes('callRecord')) {
            this.selectedItem = this.menuList.find(item => item.id === 13);
            this.selectedItem.path = urlWithOutParams;
        } else {
            this.selectedItem = this.menuList.find(item => item.id === 1);
        }
        this.sidebarMenuService.storeActiveHeaderMenuItem(this.selectedItem);
    }

    subscribeToRouterChangeSetActiveHeaderMenu() {
        this.subs.sink = this.routingHandlerService.onRouterChangeSetActiveHeaderMenu.subscribe(() => {
            this.handleHeaderMenuList();
        });
    }

    getViewAndLoggedInUserDetails() {
        this.loggedInUserDetails = this.loggedInUserService.getLoggedInUserDetails();
        this.handeleStatus();
    }

    // onMenuClick(selectedItem: any) {
    //     localStorage.removeItem('reportTypeId'); //remove localStorage when navigate from periodic review
    //     localStorage.removeItem('reportType');//remove localStorage when navigate from periodic review
    //     localStorage.removeItem('reportTabId' );//remove localStorage when navigate from periodic review
    //     localStorage.removeItem('reportReview');//remove localStorage when navigate from periodic review
    //     var nav = document.getElementsByClassName('responsive__active');
    //     if (nav.length > 0) this.isShowDivIf = !this.isShowDivIf;
    //     this.resetRequestsPath();
    //     this.selectedItem = selectedItem;

    //     // Check if the path exists before navigating
    // if (selectedItem.path) {
    //     this.routingHandlerService.navigateTo(selectedItem.path);
    //     this.sidebarMenuService.storeActiveHeaderMenuItem(selectedItem);
    // }

    //     // this.routingHandlerService.navigateTo(selectedItem.path);
    //     // this.sidebarMenuService.storeActiveHeaderMenuItem(selectedItem);

    // }

    onMenuClick(selectedItem: any) {
        if (selectedItem.id === 15) {
            if (this.isNavigatingToDelegation) {
                return;
            }

            this.isNavigatingToDelegation = true;
            // Store active header menu item
            this.sidebarMenuService.storeActiveHeaderMenuItem(selectedItem);
            this.selectedItem = selectedItem;

            if (this.router.url.includes('/delegation')) {
                // If we're already on a delegation route, just refresh the data
                this.delegationService.navigateToFirstAvailableMenuItem();

                // Reset flag after a delay
                setTimeout(() => {
                    this.isNavigatingToDelegation = false;
                }, 1000);
                return;
            }

            // Normal navigation to delegation if not already there
            this.router.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
                // Then navigate to delegation
                this.router.navigate(['/delegation']).then(() => {
                    // Reset flag only after navigation is complete
                    setTimeout(() => {
                        this.isNavigatingToDelegation = false;
                    }, 1000);
                });
            });
            return;
        }
        if (selectedItem.name !== 'requests' && selectedItem.name !== 'aboutSTS') {
            this.isCollapsed = true;
        }

        // Clear local storage items
        localStorage.removeItem('reportTypeId');
        localStorage.removeItem('reportType');
        localStorage.removeItem('reportTabId');
        localStorage.removeItem('reportReview');

        // Handle responsive menu
        var nav = document.getElementsByClassName('responsive__active');
        if (nav.length > 0) this.isShowDivIf = !this.isShowDivIf;

        this.resetRequestsPath();
        this.selectedItem = selectedItem;

        // Special handling for call record navigation
        if (selectedItem.name === 'callRecord' || (selectedItem.path && selectedItem.path.includes('callRecord'))) {
            const userPath = this.routingHandlerService.getUserPathFromRole(this.userRole);
            const callRecordPath = `/${userPath}/callRecord`;

            // Use special method for call record navigation
            this.routingHandlerService.navigateToCallRecord(callRecordPath);

            // Update the active menu item after navigation
            setTimeout(() => {
                this.sidebarMenuService.storeActiveHeaderMenuItem(selectedItem);
            }, 100);

            return;
        }

        // Standard navigation for items with paths
        if (selectedItem.path) {
            // Check if this is a dropdown item
            const isSubMenuItem = selectedItem.id !== undefined && [1, 2, 5, 6, 13].includes(selectedItem.id);

            // Use clear state option for sub-menu items
            this.routingHandlerService.navigateTo(selectedItem.path, {
                clearState: isSubMenuItem
            });

            // Store the active header menu item
            this.sidebarMenuService.storeActiveHeaderMenuItem(selectedItem);
        }
    }

    resetRequestsPath() {
        const userPath = this.routingHandlerService.getUserPathFromRole(this.userRole);
        let item = this.menuList.find(item => item.id === 5);
        if (item) {
            item.path = '/' + userPath + '/new-requests';
        }
    }

    onLogout() {
        this.apiRequestService.empolyeeUNAvailable().subscribe(response => {});
        this.authService.logout();
    }

    isAdmin() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('userRole') === USER_ROLE.ADMIN;
        } else {
            return null;
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
    change(e: any) {
        const value = e.checked;
        if (value == true) {
            this.statusText = 'active';
            this.checked = true;
            this.apiRequestService.empolyeeAvailable().subscribe(response => {});
        } else {
            this.statusText = 'notActive';
            this.checked = false;

            this.apiRequestService.empolyeeUNAvailable().subscribe(response => {});
        }
    }
    updateMenuWithSubItems(menuList: IMenuItem[], itemsToRemove: number[], newMenuName: string, id: number) {
        const subItems: IMenuItem[] = [];
        // Remove items dynamically and collect them into subItems array
        const updatedMenuList = menuList?.filter(item => {
            if (itemsToRemove.includes(item.id)) {
                subItems.push(item); // Collect the items to remove into subItems
                return false; // Remove from original list
            }
            return true;
        });

        // Add a new menu section with the collected subitems
        updatedMenuList.push({
            // id: id,
            name: newMenuName,
            path: null,
            subItems: subItems,
            secondary_id: id
        });
        this.dynamicMenuList = updatedMenuList.sort((a, b) => a.secondary_id - b.secondary_id);
        return updatedMenuList;
    }
}
